var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    className: "icon-plus_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.41 8.93h-6.695V2.26c0-.566-.506-1.03-1.07-1.03s-1.07.463-1.07 1.03v6.67H1.967C1.4 8.93.938 9.435.938 10s.463 1.07 1.03 1.07h6.605v6.63c0 .566.506 1.03 1.07 1.03s1.07-.463 1.07-1.03v-6.63h6.695c.566 0 1.03-.506 1.03-1.07s-.463-1.07-1.03-1.07z"
  })));
}
export default SvgIconPlus;